<template>
  <div>
    <loading-anim v-if="$store.state.loading" :active="$store.state.loading" fullScreen></loading-anim>
    <b-alert show variant="danger" v-if="form.state.errors"><span v-html="submitError"></span></b-alert>
    <div v-if="confirmSucessful">
      <p>{{ $t('account.confirm-account-h1') }}</p>
      <base-button class="mt-3" v-if="!passwordUpdated" @click="goToUpdatePassword">{{ $t('account.password-update.set-password') }}</base-button>
    </div>
    <div v-else-if="confirmSucessful === false">
      <p> {{ $t('account.confirm-account.steps-reenable') }} </p>
      <base-input v-model="emailResend" placeholder="Email"></base-input>
      <base-button class="mt-3" @click="resendEmail">{{ $t('account.confirm-account.resend-enable-account') }}</base-button>
    </div>
  </div>
</template>

<script>
import { BForm, BAlert, BFormGroup, BButton, BIconEyeSlash, BIconEye } from 'bootstrap-vue'
import accountRepository from '@/repositories/AccountRepository'
import { password } from '@/plugins/customValidators'
import { validationsMixin } from '@/mixins/validations.mixin'
import { required, sameAs } from 'vuelidate/lib/validators'
import LoadingAnim from '@/components/utils/LoadingAnim'
import accountMixin from '@/mixins/account.mixin'

export default {
  mixins: [accountMixin, validationsMixin],
  components: {
    BForm, BAlert, BFormGroup, BButton, BIconEyeSlash, BIconEye, LoadingAnim

  },
  data () {
    return {
      visible: false,
      code: null,
      token: null,
      confirmSucessful: null,
      submitError: null,
      passwordUpdated: false,
      form: {
        state: {
          submitted: false,
          waiting: false,
          unauthorized: false,
          errors: false
        },
        password: null,
        confirmedPassword: null
      },
      pwdToken: null,
      showPassword: false,
      emailResend: null
    }
  },
  validations: {
    form: {
      password: password,
      confirmedPassword: {
        required,
        sameAsPassword: sameAs('password')
      }
    }
  },
  methods: {
    resendEmail () {
      if (!this.emailResend) {
        this.submitError = this.$t('account.confirm-account.email-required')
        return
      }
      const email = this.emailResend.trim()
      accountRepository.sendPasswordUpdateEmail(email).then((response) => {
        if (response.data) {
          this.$router.push({ path: '/cuenta/registro-correcto', query: { email: email, confirmSucessful: false } })
        }
      })
    },
    goToUpdatePassword () {
      const query = { t: this.token }
      const returnUrl = this.$route.query.returnUrl || this.$route.query.ReturnUrl
      if (returnUrl) {
        query.returnUrl = returnUrl
      }
      this.$router.push({ path: '/cuenta/actualizar-contrasena', query })
    }
  },
  created () {
    const code = this.$route.query.code
    const token = this.$route.query.t

    if (!token && !code) {
      this.$router.push('/unauthorized')
    } else {
      this.code = code
      this.token = token
    }
        accountRepository.confirmEmail(this.code, this.token).then((response) => {
          if (response && !response.toString().includes('Error:')) {
            this.confirmSucessful = true
          } else if (response.response.status === 401) {
            this.form.state.errors = true
            this.confirmSucessful = false
            this.submitError = this.$t('account.confirm.error')
          }
        }).catch((error) => {
          this.form.state.errors = true
          if (error.response.status === 401) {
            this.confirmSucessful = false
            this.submitError = this.$t('account.confirm.error')
          }
        })
  }
/*   mounted () {
    const pwdToken = this.$route.query.t
    if (!pwdToken) {
      this.$router.push('/unauthorized')
    } else {
      this.pwdToken = pwdToken
    }
  } */
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/views/account/ConfirmEmail.vue